import { Component, input } from '@angular/core';
import { ProjectPublicResponse } from '@app/models/project.models';
import { CardComponent } from '@app/ui-components/card/card.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-project-details-section-h',
  imports: [TranslatePipe, CardComponent],
  templateUrl: './project-details-section-h.component.html',
  styleUrl: './project-details-section-h.component.scss',
})
export class ProjectDetailsSectionHComponent {
  projectDetails = input.required<ProjectPublicResponse>();
  protected translationKey = 'projectDetails.sectionH.';
}
